export const profileRoleOptions = [
  { value: 'Non definita', label: 'Non definita' },
  { value: 'Imprenditore', label: 'Imprenditore' },
  { value: 'Professionista del marketing', label: 'Professionista del marketing' },
  { value: 'Fondatore di startup', label: 'Fondatore di startup' },
  { value: 'Freelance', label: 'Freelance' },
  { value: 'Libero professionista', label: 'Libero professionista' },
  { value: 'Lavoratore autonomo', label: 'Lavoratore autonomo' },
  { value: 'Dirigente', label: 'Dirigente' },
  { value: 'Quadro', label: 'Quadro' },
  { value: 'Impiegato', label: 'Impiegato' },
  { value: 'Consulente', label: 'Consulente' },
  { value: 'Manager', label: 'Manager' },
  { value: 'Studente', label: 'Studente' },
];

export const profileSectorOptions = [
  { value: 'Non definita', label: 'Non definita' },
  { value: 'Industria', label: 'Industria' },
  { value: 'Edilizia', label: 'Edilizia' },
  { value: 'Artigianato', label: 'Artigianato' },
  { value: 'Servizi', label: 'Servizi' },
  { value: 'Commercio', label: 'Commercio' },
  { value: 'Banche / assicurazioni', label: 'Banche / assicurazioni' },
  { value: 'Trasporti', label: 'Trasporti' },
  { value: 'Istruzione', label: 'Istruzione' },
  { value: 'Cultura', label: 'Cultura' },
];

// Accept international numbers with any country code, up to E.164's 15 digits.
export const profilePhoneRegex = /^\+[1-9]\d{6,14}$/;

export function normalizeProfilePhoneNumber(value = '') {
  return String(value).replace(/\s+/g, '').trim();
}

// Use saved profile fields: a provider display name does not complete a profile.
export function hasRequiredProfileFields(user) {
  return Boolean(
    typeof user?.profile?.firstName === 'string' && user.profile.firstName.trim()
    && typeof user?.profile?.lastName === 'string' && user.profile.lastName.trim()
    && profilePhoneRegex.test(normalizeProfilePhoneNumber(user?.phoneNumber)),
  );
}
